import { getPublicAppUrl } from './public-url';

export function openPresentationWindow(path: string) {
  if (typeof window === 'undefined') return;

  const url = new URL(path, window.location.origin);
  url.searchParams.set('presentation', '1');
  url.searchParams.set('publicUrl', getPublicAppUrl());

  const features = [
    'popup=yes',
    'toolbar=no',
    'location=no',
    'menubar=no',
    'status=no',
    'scrollbars=no',
    'resizable=yes',
    `left=${(window.screen as any).availLeft ?? 0}`,
    `top=${(window.screen as any).availTop ?? 0}`,
    `width=${window.screen.availWidth}`,
    `height=${window.screen.availHeight}`
  ].join(',');

  const target = window.open(url.toString(), '_blank', features);
  target?.focus();
}

export async function requestPresentationFullscreen(element: HTMLElement = document.documentElement) {
  const request = element.requestFullscreen
    || (element as any).webkitRequestFullscreen
    || (element as any).mozRequestFullScreen
    || (element as any).msRequestFullscreen;

  if (!request) return;

  try {
    await request.call(element);
  } catch {
    // Browsers may block fullscreen without a user gesture. The maximized popup remains as fallback.
  }
}

export function isPresentationFullscreen() {
  return !!(
    document.fullscreenElement
    || (document as any).webkitFullscreenElement
    || (document as any).mozFullScreenElement
    || (document as any).msFullscreenElement
  );
}

export function exitPresentation() {
  const exit = document.exitFullscreen
    || (document as any).webkitExitFullscreen
    || (document as any).mozCancelFullScreen
    || (document as any).msExitFullscreen;

  if (isPresentationFullscreen() && exit) {
    exit.call(document);
    return;
  }

  if (window.opener) {
    window.close();
  }
}
